<template>
    <div>
        <!-- 职位信息部分 -->
        <el-row>

            <el-col class="content" style="padding:30px 29px 20px 50px;">
                <p class="name">
                    <span>{{conversationVosArr.name}}</span>
                    <span style="float:right;">{{conversationVosArr.applyName}}</span>
                </p>
                <p class="user-info">
                    <span>{{conversationVosArr.workYearDesc}}</span>|
                    <span>{{conversationVosArr.age}}</span>|
                    <span>本科</span>
                </p>
                <p class="zw">
                    <span>期望职位：</span>
                    <span class="expectJob" v-for="(item,index) in conversationVosArr.expectList" :key="index">{{item.positionDesc}}</span>
                </p>
                <p class="addr">
                    <span>期望地点：</span>
                    <span class="expectAddr" v-for="(item,index) in conversationVosArr.expectList" :key="index">{{item.locationName}}</span>
                </p>
                <p class="ys">
                    <span>职位优势：</span>
                    <span class="trait" v-for="(item,index) in conversationVosArr.careerAdvantageList" :key="index">{{item.advantageDesc}}</span>
                </p>
            </el-col>

        </el-row>

    <!-- 聊天部分 -->
        <el-row class="chat-box">

        <!-- 聊天内容部分 -->
        <el-row>
            <div ref="chatBigBox" class="chat-content">

                <div ref="chatBox" class="clearfix">
                    <p class="date"><span>12:35</span></p>
        <!-- start chat -->

                    <el-col v-for="(item,index) in allInfoArr" :key="index">
                         <!-- myself -->
                        <div class="oneself userInfo" v-if="item.userType==0">
                            <el-row v-if="item.type==0">
                                <el-col :span="20">
                                    <div class="info">
                                        <span>{{item.conversationContent}}</span>
                                    </div>
                                </el-col>
                                <el-col :span="3" :offset="1">
                                    <el-avatar :src="$store.state.userImg || myUserSrc" class="userImag"></el-avatar>
                                </el-col>
                            </el-row>

                    <!-- 面试邀请 -->
                            <div class="onself userInfo" v-if="item.type==2" @click="lookInterview">
                            <el-row>
                                <el-col :span="20">
                                    <div class="urgencyInviteBox">
                                        <el-col style="height:100%;">
                                            <div class="urgencyInviteTop">
                                                <el-row>
                                                    <el-col :span="16">
                                                        <h4 class="tabel">{{form.job}}</h4>
                                                        <p class="userBox">
                                                            <span>5年</span>|
                                                            <span>27岁</span>|
                                                            <span>本科</span>
                                                        </p>
                                                    </el-col>
                                                    <el-col :span="7">
                                                        <span class="urgencyBtn">急招</span>
                                                    </el-col>
                                                </el-row>
                                                <el-row>
                                                    <el-col>
                                                        <p class="addrBox">
                                                            <span class="addr">地点:</span>
                                                            <span class="addr-info"> 武汉市洪山区现代世贸中心A栋303</span>
                                                        </p>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                            <div class="urgencyInviteBottom">
                                                <span class="particulars">立即查看</span>
                                            </div>
                                        </el-col>
                                    </div>
                                </el-col>
                                <el-col :span="4">
                                    <el-avatar :src="$store.state.userImg || myUserSrc"></el-avatar>
                                </el-col>
                            </el-row>
                            </div>

                        </div>

                    <!-- you -->
                        <div class="other-perple userInfo" v-if="item.userType==1">
                            <el-row>
                                <el-col :span="4">
                                    <el-avatar :src="conversationVosArr.headPortrait || otherUserSrc" class="userImag"></el-avatar>
                                </el-col>
                                <el-col :span="20">
                                    <div class="info">
                                        <span>{{item.conversationContent}}</span>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    <!-- 拒绝面试邀请 -->
                    <!-- <div class="other-perple userInfo" v-if="item.userType==0">
                        <el-row>
                            <el-col :span="4">
                                <el-avatar :src="conversationVosArr.headPortrait || otherUserSrc"></el-avatar>
                            </el-col>
                            <el-col :span="20">
                                <div class="info">
                                    <img class="icon" src="../../assets/error-icon.png" />拒绝面试邀请
                                </div>
                            </el-col>
                        </el-row>
                    </div> -->

                    <!-- 接收面试邀请 -->
                    <!-- <div class="other-perple userInfo" v-if="item.userType==0">
                        <el-row>
                            <el-col :span="4">
                                <el-avatar :src="conversationVosArr.headPortrait || otherUserSrc"></el-avatar>
                            </el-col>
                            <el-col :span="20">
                                <div class="info">
                                    <img class="icon" src="../../assets/success-icon.png" />接收面试邀请
                                </div>
                            </el-col>
                        </el-row>
                    </div> -->

                <!-- 工作简历 -->
                        <!-- <div class="other-perple userInfo" v-if="item.userType==0">
                            <el-row>
                                <el-col :span="4">
                                    <el-avatar :src="conversationVosArr.headPortrait || otherUserSrc"></el-avatar>
                                </el-col>
                                <el-col :span="20">
                                    <div class="resumeBox" @click="setStatus(undefined,true)">
                                        <el-col style="height:100%;">
                                            <div class="resumeTop">
                                                <span class="resumeIcon"></span>
                                                <span class="resumeFont">吴瑞琪的工作简历</span>
                                            </div>
                                            <div class="resumeBottom">
                                                <span class="lookResume">点击查看简历</span>
                                            </div>
                                        </el-col>
                                    </div>
                                </el-col>
                            </el-row>
                        </div> -->



                    </el-col>


                <!--  -->
                </div>
            </div>
        <!-- end chat -->
            </el-row>

            <el-row class="chat-input">
                <el-row>
                    <el-col class="input" style="height:100px;">
                        <el-input
                            class="inpt focus input-text"
                            style="width:100%;height:100%;"
                            type="textarea"
                            placeholder="请输入内容"
                            v-model="contentText"
                            >
                        </el-input>
                        <!-- <div class="inpt focus" contenteditable='true' style="width:100%;height:100%;background-color:red;" @input="inpt"></div>               -->
                    </el-col>
                </el-row>
                <el-row class="inp-fun">
                    <el-col :span="4" class="icon-box" @click.native="getStatus(true,undefined)">
                        <div class="interview-icon"></div>
                        <span class="interview-icon-font">面试邀约</span>
                    </el-col>
                    <el-col :span="20">
                        <el-button type="primary theme-btn" class="theme-btn fb-btn" style="width:100px; height:46px;" @click.native="issueFun('0','0')">发送</el-button>
                    </el-col>
                </el-row>
            </el-row>

        </el-row>

         <!-- 弹框 -->

        <!-- 面试邀约弹框 -->
        <el-dialog
            :visible.sync="dialogVisible"
            width="23.2%"
            :show-close="false"
            class="alert" >
            <p class="title">发送面试邀请</p>
            <div class="content">
                <el-form ref="form" :model="form" label-width="100px">
                    <el-form-item label="面试职位">
                       <el-input v-model="form.job" readonly="readonly"  class="inp"></el-input>
                    </el-form-item>
                    <el-form-item label="面试时间">
                        <el-date-picker
                            class="inp"
                            v-model="form.interviewDate"
                            type="datetime"
                            placeholder="请选择面试时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="面试地址">
                        <el-input v-model="form.addr" placeholder="请填写面试的地址" class="inp"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人">
                        <el-input v-model="form.userName" placeholder="请填写联系人" class="inp"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码">
                        <el-input v-model="form.companyTel" placeholder="请填写手机号码" class="inp"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer" style="text-align:center;">
                <el-button @click="dialogVisible = false" class="cancel">取消</el-button>
                <el-button type="primary" @click="sendInterview" class="send theme-btn">发送</el-button>
            </div>
        </el-dialog>

        <!-- 显示工作简历弹框 -->
        <el-dialog :visible.sync="showResume">
            <el-row>
                <el-col>
                    <chat-Zxjl></chat-Zxjl>
                </el-col>
            </el-row>
        </el-dialog>

        <!-- 显示职位管理弹框 -->
        <el-dialog :visible.sync="showResume">
            <el-row>
                <el-col>
                    <chat-Zxjl></chat-Zxjl>
                </el-col>
            </el-row>
        </el-dialog>


    </div>
</template>
<script>
import {webSocketConfig} from '@/utils/webSocket/webSocket.js'
import chatZxjl from '@/views/chat/chat_zxjl.vue'
export default {
    data(){

        return {
            dialogVisible: false,  // 面试邀约
            showResume:false,   // 工作简历

            postId:'',

            // newConversationVosArr:'',   // 存放最新用户信息


            form: {
                job:'',   // 职位名称
                interviewDate:'',   //面试时间
                userName:'',    // 联系人
                companyTel:'',  // 联系电话
                addr:'',    // 面试地点
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            },


            msg:'', // 存放第一次的聊天数据
            userInfo:'',    // 管理员信息
            allInfoArr:[], // 获得全部消息
            type:'',    // //消息类型，第一次登陆不要 0第一次连接 1发送简历   2发送面试邀请 3发送代招的职位  4接受了面试邀请  5拒绝了面试邀请
            receiveIdentity:'',     // 接收人身份， 第一次不需要
            generationChat:'0',      // //当前登陆用户是否为代招客服   0正常聊天   1代招客服聊天

            myUserSrc:'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            otherUserSrc:'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            contentText:''
        }
    },
    components:{
        chatZxjl
    },
    watch: {
        //监听list,当有修改的时候进行div的屏幕滚动，确保能看到最新的聊天
        allInfoArr: function () {
            let that = this;
            setTimeout(() => {
                let chatBigBox = that.$refs.chatBigBox
                let chatBox = that.$refs.chatBox
                chatBox.offsetHeight>350? chatBigBox.style.overflowY="scroll" : chatBigBox.style.overflowY="visible"

                chatBigBox.scrollTop = chatBigBox.scrollHeight;
            }, 0);
            //加setTimeout的原因：由于vue采用虚拟dom，我每次生成新的消息时获取到的div的scrollHeight的值是生成新消息之前的值，所以造成每次都是最新的那条消息被隐藏掉了
        },
        conversationVosArr(newValue,oldValue){
            console.log('newValue')
            console.log(newValue);
            // console.log(newValue.headPortrait)

            this.postId = newValue.chatInfo.postId
            this.getInfo()
            this.sendFn(null,null,newValue)
            if(newValue.chatInfo['postId']){
                this.axiosGet(`/conversation/findByCompanyId?companyId=${newValue.chatInfo.companyId}&postId=${newValue.chatInfo.postId}`).then((res)=>{
                    console.log('postId')
                    console.log(res)
                    this.c = newValue.chatInfo.sendId
                    let data = res.data[0]
                    if(res.code==200){
                        this.form.job = data.postName
                        this.form.userName = data.userName
                        this.form.companyTel = data.companyTel
                        this.form.addr = `${data.postCity}-${data.postAddress}`
                    }
                })
            }else{
                 this.axiosGet(`/conversation/findByCompanyId?userId=${newValue.chatInfo.sendId}`).then((res)=>{
                    console.log('userId')
                    console.log(res)
                })
            }

        }
    },
    compunted:{
        newConversationVosArr:function(){
            return this.conversationVosArr
        }
    },
    methods:{
        lookInterview(){
            alert(this.postId)
            // console.log('newConversationVosArr')
            // console.log(this.newConversationVosArr)
            this.axiosGet(`/interview/getInterviewById?userId=${this.postId}`).then((res)=>{
                console.log('面试详情')
                console.log(res)
                if(res.code==200){

                }
            })
        },
    // 显示发送简历弹框函数/显示工作简历弹框函数
        getStatus(isShow,status){
            // console.log(isShow,status)
            this.dialogVisible = isShow || false
            this.showResume = status || false
        },
        pageScrollToBottom(){
            let chatBigBox = this.$refs.chatBigBox
            chatBox.style.overflowY="scroll"
            this.$refs.chatBox.scrollTop = this.$refs.chatBox.scrollHeight;
            // console.log(chatBox.scrollTop,chatBox.scrollHeight)
        },
        getInterview(){
            // this.axiosPost(`/interview/add`,
            //     {
            //         companyId:this.userInfo.companyId,
            //         postId
            //     }
            // )
        },
    async  sendInterview(){
            // alert('fsdfds')
            await this.getInterview();
            await this.issueFun('2','0','dialogVisible')
        },
        issueFun(type,generationChat,isShow){     // 点击发送消息触发的函数     siShow 表示额外属性
            // console.log(this.contentText.trim())
            if(!this.contentText.trim()&&type==0)return
            let that = this
            let scoketMessage = {
                sendId:this.userInfo.id,	//发送人id
                receiveId:this.conversationVosArr.chatInfo.sendId,	//接收人id，第一次登陆不需要
                content:this.contentText,	//消息内容，第一次登陆不要
                type:type,	//消息类型，第一次登陆不要 0正常聊天 1发送简历   2发送面试邀请 3发送代招的职位  4接受了面试邀请  5拒绝了面试邀请
                status:'2'	,//状态，1就是第一次连接  2正常聊天   3心跳包
                identityStatus:'1',	//当前登陆用户身份 0个人或者1企业
                conversationId:this.conversationVosArr.chatInfo.conversationId,	//当前会话id
                generationChat:generationChat,	//是否代招会话	0不是 1是
                generationCompanyId:this.conversationVosArr.chatInfo.companyId,	//公司id
                receiveIdentity:'0'   //  接收人身份
            }



            // let scoketMessageInterview = {
            //     sendId:this.userInfo.id,	//发送人id
            //     receiveId:this.conversationVosArr.chatInfo.sendId,	//接收人id，第一次登陆不需要
            //     content:this.contentText,	//消息内容，第一次登陆不要
            //     type:type,	//消息类型，第一次登陆不要 0正常聊天 1发送简历   2发送面试邀请 3发送代招的职位  4接受了面试邀请  5拒绝了面试邀请
            //     status:'2'	,//状态，1就是第一次连接  2正常聊天   3心跳包
            //     identityStatus:'1',	//当前登陆用户身份 0个人或者1企业
            //     receiveIdentity:'0',   //  接收人身份
            //     generationChat:generationChat,	//是否代招会话	0不是 1是
            //     interviewId:'',
            //     generationPostId:'',
            //     postId:'',
            //     conversationId:this.conversationVosArr.chatInfo.conversationId,	//当前会话id
            //     generationCompanyId:this.conversationVosArr.chatInfo.companyId,	//公司id

            // }

            console.log('发送消息')
            this.sendFn(scoketMessage,function(){
                that.contentText = ''
            })
            // if(type==2){
            //     that.lookInterview()
            // }

            if(isShow){
                this[isShow] = false
            }
        },
        sendFn(textInfo,callBack,newVal){
            let that = this
            let ws = new WebSocket("wss://recruit.xuruidea.com/ws");
            if(textInfo){
                ws.onopen = function (e) {
                    console.log("链接服务器成功");
                    ws.send(JSON.stringify(textInfo));
                };
            }
            socket.onmessage = function(response){
                let msgRes = JSON.parse(response.data)
                console.log('msgRes')
                console.log(msgRes)
                if(newVal){
                    // console.log('msgRes')
                    // console.log(msgRes.conversationId,newVal.chatInfo.conversationId)
                    if(msgRes.conversationId!=newVal.chatInfo.conversationId){return}
                }
                    // console.log('newConversationVosArr')
                    // console.log(that.newConversationVosArr)
                    // console.log('接收到消息')
                    // console.log(JSON.parse(response.data))
                // this.allInfoArr.push()
                // console.log('所有消息')
                // console.log(that.allInfoArr)
                let userType = msgRes.sendId==that.userInfo.id? '0':'1'   // 1 管理员消息 0 客户消息
                let msgObj = {
						conversationContent: msgRes.content,    // 内容
						type: msgRes.type,  // 类型
						sendId: msgRes.sendId,
						personalStatus: 2,
                        userType:userType,
					}
                that.$nextTick(()=>{
                    that.allInfoArr.push(msgObj)
                })
                console.log('allInfoArr111')
                console.log(that.allInfoArr)
            }
            if(callBack){
                callBack()
            }
        },
        getInfo(){
            this.axiosGet(`/conversationInfo/findByConversationId?conversationId=${this.conversationVosArr.chatInfo.conversationId}&identityStatus=${this.userInfo.identityStatus}&userId=${this.userInfo.id}&updateEmp=${this.userInfo.id}`).then((res)=>{
                // console.log('聊天信息')
                // console.log(res)
                if(res.code==200){
                    res.data.conversationInfoVos.forEach((item,index)=>{
                        // console.log(item.userId,this.userInfo.id)
                        item.userType = item.userId==this.userInfo.id? '0':'1'   // 1 管理员消息 0 客户消息
                    })
                    this.allInfoArr = res.data.conversationInfoVos  // 存放所有消息
                    // console.log('allInfoArr')
                    // console.log(this.allInfoArr)

                }
            })
        }
    },
    props:['conversationVosArr'],   // 存放接收人信息
    mounted(){
        let that = this
        document.querySelector('.input-text').onkeydown = function(){
            if(event.keyCode==13){
                that.issueFun('0','0')
                that.contentText = that.contentText.trim()
            }
        }
    },
    created(){
        this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    }
}
</script>
<style lang="less" scoped>
    .icon{
        width:20px;
        height:20px;
        vertical-align:middle;
        margin-right:5px;
    }
    .expectJob,
    .expectAddr{
        margin-right:15px;
    }
    .name{
        span:first-of-type{
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
        }
        span:last-of-type{
            font-size: 14px;
            font-weight: 400;
            color: #1A80FC;
            line-height: 30px;
        }
    }

    .user-info{
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 30px;
            span{
                padding:0 5px;
            }
            span:first-of-type{
                padding-left:0;
            }
    }

    .ys span.trait{
            display:inline-block;
            background:rgb(234,240,255);
            text-align:center;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 400;
            color: #1A80FC;
            line-height:30px;
            width:80px;
            margin-right:7px;
    }
    .zw span:last-of-type,
    .addr span:last-of-type{
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
    }

    .zw span:first-of-type,
    .addr span:first-of-type,
    .ys span:first-of-type {

        font-size: 16px;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
    }

//  聊天部分
    .chat-box{
        height:500px;
    }

// 日期部分
    .date{
        text-align:center;
        font-size: 14px;
        font-weight: 400;
        color: #868EA7;
        line-height: 30px;
        margin-bottom:30px;
    }

// 聊天内容部分
    .chat-content{
        // background-color:red;
        height:350px;
        padding:0 5%;

    // 自己
        .oneself{
            text-align:right;
            width:63.5%;
            float:right;
            clear:both;
            .el-avatar--circle{
                vertical-align:middle;
            }
            .info{
                display:inline-block;
                background:#1A80FC;
                padding:5px 10px;
                text-align: left;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 400;
                color:#ffffff;
            }
        }
    //他人
        .other-perple{
            width:63.5%;
            text-align:left;
            float:left;
            clear:both;
            .el-avatar--circle{
                vertical-align:middle;
            }
            .info{
                display:inline-block;
                background:rgb(234,240,255);
                padding:5px 10px;
                text-align: left;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 400;
                color: #868EA7;
            }
        }
        .userInfo{
            margin-top:10px;
        }


// 工作简历
        .resumeBox{
            height:142px;
            background-color:#EAF0FF;
            height: 142px;
            border-radius: 4px;
            cursor:pointer;

            .resumeTop{
                box-sizing:border-box;
                text-align:center;
                line-height:80px;
                height:65%;
                border-bottom:solid 1px #ffffff;
                .resumeFont{
                    font-size:18px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 30px;
                }
                .resumeIcon{
                    display:inline-block;
                    margin-right:17px;
                    width:39px;
                    height:39px;
                    background:url('../../assets/_20201010150712.png') no-repeat;
                    vertical-align:middle;
                }
            }
            .resumeBottom{
                height:34%;
                // line-height:50px;
                text-align:center;
                .lookResume{
                    font-size: 14px;
                    font-weight: 400;
                    color: #1A80FC;
                    line-height: 50px;
                }
            }
        }

// 急招

        .urgencyInviteBox{
            height:167px;
            box-sizing:border-box;
            padding:15px;
            background-color:#EAF0FF;
            cursor:pointer;
            .urgencyInviteTop{
                height:69%;
                // ;background-color:red
                border-bottom:solid #ffffff 1px;
                .userBox{
                    font-size: 14px;
                    font-weight: 400;
                    color: #666666;
                    line-height: 30px;
                    span{
                        padding:0 5px;
                    }
                }
                .tabel{
                    font-size: 18px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 30px;
                }
                .urgencyBtn{
                    float:right;
                    background: #FF7D26;
                    border-radius: 8px;
                    width:78%;
                    height:32px;
                    line-height:32px;
                    text-align:center;
                    font-size: 16px;
                    font-weight: 400;
                    color: #FFFFFF;
                }
            }
            .urgencyInviteBottom{
                height:30%;
                // background-color:blue;
                text-align:center;
                line-height:56px;
                .particulars{
                    font-size: 14px;
                    font-weight: 400;
                    color: #1A80FC;
                    line-height: 30px;
                }
            }
            .addrBox{
                .addr{
                    font-size: 16px;
                    font-weight: 400;
                    color: #666666;
                    line-height: 30px;
                }
                .addr-info{
                    font-size: 16px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 30px;
                }
            }
        }



    }




// 聊天输入内容部分
    .chat-input{
        height:150px;
        border-top:solid 1px #e6ecf8;
    }
    .interview-icon{
        width:27px;
        height:26px;
        background:url('../../assets/sendInterview.png') no-repeat;
        background-size:contain;
        margin:0 auto;
    }
    .interview-icon-font{
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
    }
    .icon-box{
        // background-color:yellow;
        text-align:center;
        cursor:pointer;
    }
    .fb-btn{
        float:right;
        width:100px;
        height:46px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        position:relative;
        top:5px;
        right:10px;
        border-radius: 8px;
        border:none;
    }


    // 发送面试邀请弹框
        .title{
            text-align:center;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
        }
        .cancel,
        .send{
            width:100px;
            height:46px;
        }
        .send{
            font-size: 16px;
            font-weight: 400;
            color: #FFFFFF;
            margin-left:15%;
        }
        .cancel{
            font-size: 18px;
            font-weight: 400;
            color: #868EA7;
        }
        .inp{
            width:88%;
        }

</style>
